var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C7.03412 3 3 7.03412 3 12C3 16.9659 7.03412 21 12 21C16.9659 21 21 16.9659 21 12C21 7.03412 16.9659 3 12 3ZM12 19.9412C7.61647 19.9412 4.05882 16.3835 4.05882 12C4.05882 7.61647 7.61647 4.05882 12 4.05882C16.3835 4.05882 19.9412 7.61647 19.9412 12C19.9412 16.3835 16.3835 19.9412 12 19.9412Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0925 11.9189C12.4048 11.9189 12.7172 12.3968 12.8788 12.5H15C15.3232 12.5 15.5 12.2556 15.5 12C15.5 11.7444 15.3232 11.5 15 11.5H12.8573C12.7926 11.4295 12.5646 11.4513 12.5 11.4072V6.96708C12.5 6.71151 12.3232 6.5 12 6.5C11.6768 6.5 11.5 6.71151 11.5 6.96708V11.4072C11.6041 11.4896 12.2253 11.7773 12.2253 12.0329C12.2253 12.4647 11.5539 11.9189 12.0925 11.9189Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1,
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.377ab85179999c63ad1ab316a2ee2931.svg";
export { ForwardRef as ReactComponent };